<div class="orders-modal">
  <div class="orders-modal__backdrop"
       (click)="closeModal()"
  ></div>
  <div class="orders-modal__container">
    <svg
      class="orders-modal__container--close-button"
      aria-label="Cart image"
      (click)="closeModal()"
    >
      <use xlink:href="./assets/images/icons-sprite.svg#icon-close"></use>
    </svg>

    <div class="orders-modal__container--header">
      <p class="orders-modal__container--header-text"
         [ngStyle]="{color: addColorToStatus(currentOrder.status)}"
      >

        {{replacementStatus(currentOrder.status)}}
      </p>
    </div>

    <div class="orders-modal__container--content">

      <div class="orders-modal__container--content--info">
        <span class="orders-modal__container--text">
          #{{currentOrder.number}}
        </span>
        <span class="orders-modal__container--text">
          {{currentOrder.datetime_created | date: 'shortTime'}}
        </span>
      </div>

      <div class="orders-modal__item--container">
        <div class="orders-modal__item--line-items"
             *ngFor="let item of currentOrder.lineItems"
        >
          {{item.quantity}} x {{item.name}} ({{item.variation.name}})
          <div class="orders-modal__item__modifiers--container"
               *ngIf="item.modifiers"
          >
            <ul class="orders-modal__item__modifiers--list">
              <li *ngFor="let modifier of item.modifiers">{{modifier.name}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="orders-modal__container--footer"
         *ngIf="isKitchen"
    >
      <button class="orders-modal__container--footer-button"
              (click)="updateOrderStatus(currentOrder.status, locationId, currentOrder.orderId)"
      >
        {{replacementStatusForActionButton(currentOrder.status)}}
      </button>
    </div>

  </div>
</div>

